import React from 'react'
import { connect } from 'react-redux'
import Popup from 'reactjs-popup'
import Loader from 'react-loader-spinner'
import * as actions from '../redux/actions'
import { AiOutlineClose, AiOutlineStar, AiFillStar } from 'react-icons/ai'
import rp from 'request-promise-native'
import { uriV2 } from './defaultProps'
import moment from 'moment'

const styles = {
  popupContentContainer: {
    display: 'flex',
    justifyContent: 'center',
    flexFlow: 'column',
    alignItems: 'center',
    padding: '8px',
    paddingRight: '16px'
  },
  popupHeaderClose: {
    display: 'flex',
    flexFlow: 'row',
    justifyContent: 'space-between',
    width: '100%'
  },
  popupHeader: {
    margin: '0',
    color: '#3E3E3E',
    fontSize: '24px'
  },
  popupParagraph: {
    textAlign: 'left',
    width: '100%',
    fontSize: '20px'
  },
  popupInput: {
    width: '100%',
    border: '0'
  },
  popupCheckbox: {
    marginTop: '20px',
    marginBottom: '10px',
    fontSize: '16px',
    width: '100%'
  },
  popupStar: {
    display: 'flex',
    flexFlow: 'row',
    cursor: 'pointer'
  },
  popupDivisor: {
    width: '100%',
    margin: '8px',
    backgroundColor: '#a2a2a2',
    height: '1px'
  },
  popupAcceptButton: {
    flex: 1,
    color: '#ffffff',
    cursor: 'auto',
    textAlign: 'center',
    borderRadius: '16px',
    margin: '16px 0px 4px 4px',
    paddingTop: '8px',
    paddingBottom: '4px',
    fontWeight: 'bold',
    backgroundColor: '#707070'
  },
  popupNoEvaluationButton: {
    flex: 1,
    color: '#ffffff',
    textAlign: 'center',
    borderRadius: '16px',
    margin: '16px 4px 4px 0px',
    paddingTop: '8px',
    paddingBottom: '4px',
    fontWeight: 'bold',
    backgroundColor: '#ff0000',
    cursor: 'pointer'
  },
  popupContentStyle: {
    maxWidth: '768px',
    width: '100%',
    margin: 'auto',
    backgroundColor: '#E0E0E0'

  },
  popupOverlayStyle: {
    padding: '16px'
  },
  buttonsContainer: {
    display: 'flex',
    flexFlow: 'row',
    width: '100%'
  }
}

class Evaluation extends React.Component {
  constructor (props) {
    super(props)
    const star = { visible: false }
    this.state = {
      showPopup: false,
      loading: false,
      rating: 0,
      stars: [star, star, star, star, star]
    }
  }

  componentDidMount () {
    // Checks when you are already logged in
    if (this.props.token && this.props.user) {
      this.showsPopup()
    }
  }

  componentDidUpdate (prevProps) {
    if (
      (!prevProps.token && this.props.token) ||
      (prevProps.display !== this.props.display)
    ) {
      this.showsPopup()
    }
  }

  showsPopup = () => {
    const awaitShowPopup = moment(this.props.lastShow)
    awaitShowPopup.add(1, 'days')

    if (moment().isAfter(awaitShowPopup)) {
      this.props.hideModal()
    }

    if (!this.props.user.clientRating &&
      this.props.user.status === 'inactive' &&
      this.props.user.afilliationType === 'mostyAndConsultant' &&
      !this.props.user.noRatingOption &&
      this.props.display === false) {
      this.props.showModal()
      this.openPopup()
    }
  }

  noEvaluation = async () => {
    this.setState({loading: true})
    const data = {
      noRatingOption: true
    }
    try {
      await rp({
        uri: `${uriV2}/user/rating/option`,
        method: 'POST',
        headers: {
          Authorization: this.props.token
        },
        body: data,
        json: true
      })
      this.setState({showPopup: false})
    } catch (err) {
      console.error('Erro ao salvar as informações: ', err)
    } finally {
      this.setState({loading: false})
    }
  }

  saveEvaluation = async () => {
    this.setState({loading: true})
    const data = {
      rating: this.state.rating,
      comment: this.refs.evaluationText.value,
      anonymousUser: this.refs.anonymous.checked
    }
    try {
      await rp({
        uri: `${uriV2}/user/rating`,
        method: 'POST',
        headers: {
          Authorization: this.props.token
        },
        body: data,
        json: true
      })
      this.setState({showPopup: false})
    } catch (err) {
      console.error('Erro ao salvar as informações: ', err)
      if (err.statusCode === 409) {
        window.alert('Você já avaliou sua consultora.')
      } else if (err.statusCode === 400) {
        window.alert(`Erro de validação.`)
      } else {
        window.alert(`Erro de conexão.`)
      }
    } finally {
      this.setState({loading: false})
    }
  }

  openPopup = () => this.setState({showPopup: true})

  renderLoader = () => {
    return (
      <div style={styles.popupContentContainer}>
        <Loader
          type='TailSpin'
          color='#6d357b'
          height='50'
          width='50'
        />
      </div>
    )
  }

  setStarVisible = (index) => {
    const { stars } = this.state
    for (let i = 0; i <= index; i++) {
      stars[i] = { visible: true }
    }
    this.setState({ stars, rating: index + 1 })
    this.refs.buttonSend.style.backgroundColor = '#6D357B'
    this.refs.buttonSend.style.cursor = 'pointer'
  }

  setStarInvisible = (index) => {
    const { stars } = this.state
    for (let i = this.state.stars.length - 1; i > index; i--) {
      stars[i] = { visible: false }
    }
    this.setState({ stars, rating: index + 1 })
  }

  renderPopupContent = () => {
    return (
      <div style={styles.popupContentContainer}>
        <div style={styles.popupHeaderClose}>
          <p style={styles.popupHeader}>
            Avalie sua consultora
          </p>
          <AiOutlineClose size='30' color='#707070' onClick={() => this.setState({showPopup: false})} />
        </div>
        <div style={styles.popupDivisor} />
        <p style={styles.popupParagraph}>
          Qual nota você dá para a consultoria de {this.props.user.consultantName}? *
        </p>
        <div style={styles.popupStar}>
          {this.state.stars.map((elem, index) =>
            <div key={index}>
              {elem.visible === false
                ? <AiOutlineStar size='30' color='#CC7A0E' style={{ borderColor: '#ffffff' }} onClick={() => this.setStarVisible(index)} />
                : <AiFillStar size='30' color='#CC7A0E' style={{ borderColor: '#ffffff' }} onClick={() => this.setStarInvisible(index)} />
              }
            </div>
          )}
        </div>
        <p style={styles.popupParagraph}>
          Faça um comentário sobre a consultoria com a {this.props.user.consultantName}.
        </p>
        <textarea style={styles.popupInput} type='text' id='evaluation-text' ref='evaluationText' name='text-evaluation' maxLength='255' rows='6' />
        <div style={styles.popupCheckbox}>
          <input type='checkbox' id='anonymous' ref='anonymous' name='checkbox-anonymous' />
          <label>Não desejo mostrar meu nome na avaliação.</label>
        </div>
        <div style={styles.buttonsContainer}>
          <div style={styles.popupNoEvaluationButton} id='button-no-evaluation' ref='buttonNoEvaluation'
            onClick={() => this.noEvaluation()}
          >
            Não quero avaliar
          </div>
          <div style={styles.popupAcceptButton} id='button-send' ref='buttonSend'
            onClick={() => this.state.rating !== 0 && this.saveEvaluation()}
          >
            Enviar Avaliação
          </div>
        </div>
      </div>
    )
  }

  renderPopup = () => {
    return (
      <Popup
        open={this.state.showPopup}
        position='right center'
        contentStyle={styles.popupContentStyle}
        overlayStyle={styles.popupOverlayStyle}
        closeOnDocumentClick={false}
      >
        <div className='modal'
        >
          {this.state.loading ? this.renderLoader() : this.renderPopupContent() }
        </div>
      </Popup>
    )
  }

  render () {
    return (
      <React.Fragment>
        {this.props.children}
        {this.state.showPopup && this.renderPopup()}
      </React.Fragment>
    )
  }
}

const mapSateToProps = state => ({
  token: state.userReducer.token,
  user: state.userReducer.user,
  lastShow: state.evaluationReducer.lastShow,
  display: state.evaluationReducer.display
})

export default connect(
  mapSateToProps,
  actions
)(Evaluation)



// WEBPACK FOOTER //
// ./src/services/Evaluation.js